import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.PAYOUTS_SEARCH_START_LOADING,
    success: AppConstants.PAYOUTS_SEARCH_SUCCESS
};

const PublisherPayoutsActions = {
    getPayouts(params, callback, events = defEvents) {
        dispatch({
            type  : events.before
        });

        return api.searchPayouts(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err);
            });

    }
};

export default PublisherPayoutsActions;
